import { createAction, props } from '@ngrx/store';
import { ICartPopup } from './cart-popup.interface';

export const SetCartPopup = createAction('[Cart popup] Set', props<{ options: ICartPopup; }>());
